<div class="container">
  @if (siteData.footer.isDefault) {
    <div class="footer">
      <div nz-row>
        <div nz-col nzXs="4" nzSm="14" class="left">
          <img [src]="siteData.footer.footerLogo" alt="" />
          <span>&copy; Copyright {{ currentYear }}. All Rights Reserved.</span>
        </div>
        <div nz-col nzXs="20" nzSm="10" class="right">
          <a routerLink="/privacy-policy">Privacy Policy</a>
          <a routerLink="/terms-of-service">Terms and Conditions</a>
          @if (siteData.footer.cloudstaffLink) {
            <a
              href="https://www.cloudstaff.com"
              title="Visit Cloudstaff Official Website"
              >Cloudstaff Official Website</a>
          }
          @if (siteData.footer.client.isShow) {
            <a
              [href]="siteData.footer.client.website"
              >
              <img
                [src]="siteData.footer.client.logo"
                target="_blank"
                alt="Client Logo"
                class="client-logo"
                />
              </a>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="footer">
        <div class="container">
          <div class="ant-row">
            <div
              class="footer-brand ant-col ant-col-xs-12 ant-col-sm-12 ant-col-md-12 ant-col-lg-12"
              >
              <div class="ant-row">
                <div class="footer-brand-logo">
                  <a href="https://lumierelifestylegroup.com.au">
                    <img src="/assets/lumiere/images/logo.png" />
                  </a>
                </div>
                <div class="footer-brand-logo-content">
                  <h3>Lumiere Foundation Ltd</h3>
                  <p>Suite 202, 189 Queen Street</p>
                  <p>Melbourne VIC 3000</p>
                  <p>&copy; Limiere Foundation 2025</p>
                </div>
              </div>
            </div>

            <div
              class="footer-navigator ant-col ant-col-xs-12 ant-col-sm-12 ant-col-md-12 ant-col-lg-12 text-end"
              >
              <div class="ant-row text-end">
                <div class="footer-brand-navigator text-end">
                  <!-- toggle (hidden checkbox) -->
                  <input
                    type="checkbox"
                    id="fbn-toggle"
                    class="fbn-toggle"
                    aria-label="Toggle menu"
                    />
                    <label
                      for="fbn-toggle"
                      class="fbn-toggle-btn"
                      aria-hidden="true"
                    ></label>
                    <ul class="fbn-list text-end">
                      <li><a href="/privacy-policy">Pivacy policy</a></li>
                      <li><a href="/terms-of-service">Terms of use</a></li>
                      <li>
                        <a href="https://lumierelifestylegroup.com.au">Contact us</a>
                      </li>
                      <li>
                        <a href="tel:+61391004803"><b>+61 3 9100 4803</b></a>
                      </li>
                    </ul>
                  </div>

                  <div class="footer-features">
                    <a href="https://www.acnc.gov.au" target="_blank">
                      <img src="/assets/lumiere/images/ACNC.png" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
